import { render, staticRenderFns } from "./CalleePeer.vue?vue&type=template&id=4d918536&"
import script from "@/scripts/CalleePeer.js?vue&type=script&lang=js&"
export * from "@/scripts/CalleePeer.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports